module.exports = __webpack_public_path__ + "img/audio.47991b44.gif";